
const filterSearchConditions = (conditions) => {
    if (conditions.hasCustomer === 'Either') {
        delete conditions.hasCustomer;
    }

    return conditions;
}

export default filterSearchConditions;